import { cn } from "@/utils/cn";
import { memo } from "react";

interface SparkleIconProps {
  className?: string;
}

export const SparkleIcon = memo(function SparkleIcon({ className }: SparkleIconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn("stroke-[#620AD5]", className)}
    >
      <path
        d="M9.65332 4.76367C10.837 7.09324 13.3118 10.1346 17.4922 11.9893C15.0127 13.0424 11.6019 15.2302 9.66211 19.373C8.57527 17.0274 6.32239 13.9263 2.19824 12.0576C4.58777 11.026 7.7785 8.89612 9.65332 4.76367Z"
        strokeWidth="1.5"
      />
      <path
        d="M17.8684 1.76465C18.2935 2.37885 18.8977 3.01975 19.7131 3.54004C19.0725 3.94059 18.3889 4.52578 17.8469 5.36328C17.4524 4.74611 16.886 4.09785 16.092 3.57324C16.7049 3.17746 17.3515 2.59956 17.8684 1.76465Z"
        strokeWidth="1.5"
      />
    </svg>
  );
});
